import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/firefly.webp';
import screenshot_target from '../../../images/letterfunnel/frankvisser.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Frank Visser"
      firstname="Frank"
      companyname="Firefly"
      competition="INGY en MyMesh"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/frankvisser.js